import { Grid, Typography, TextField, FormControl, InputLabel, MenuItem, Box } from "@mui/material"
import { DatePicker } from "@mui/x-date-pickers"
import moment from "moment"
import { Control, Controller } from "react-hook-form"
import { EducationType, ExperienceType } from "../Schemas/ResumeSchemas";
import { KaziCheckbox } from "./Kazi/KaziCheckbox";

interface IProps {
    control: Control<ExperienceType, any>;
    presentChecked?: boolean;
}

export const ExperienceFields = ({ control, presentChecked = false }:IProps) => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <>
            <Grid item sx={{overflowY: "auto"}}  maxHeight={"550px"} gap={'20px'} display={"flex"} flexDirection={"column"} paddingRight={4}>
            <Grid item display={"flex"} flexDirection={"row"} gap={"12px"}>
                    <Grid item display={"flex"} flexDirection={"column"} flex={1}>
                        <Typography variant='body-small' color={'black.200'} marginBottom={1}>Start</Typography>  
                        <Controller
                            name="start_date"
                            control={control}
                            rules={{required: true}}
                            render={({ field }) =>( 
                                    <DatePicker
                                        {...field}
                                        disableFuture
                                        slotProps={{
                                            textField: {
                                                placeholder: 'Start month and year'
                                            },
                                            field: {
                                                clearable: true
                                            }
                                        }}
                                        value={field?.value ? moment(field.value).local() : undefined} 
                                        format='MM YYYY'
                                        views={['month', 'year']}                          
                                    />
                            )}
                        />   
                    </Grid>
                    <Grid item display={"flex"} flexDirection={"column"} flex={1}>
                        <Box display={'flex'} flexDirection={'row'} marginBottom={1}>
                            <Box display={'flex'} flexDirection={'row'} flex={1}>
                                <Typography variant='body-small' color={'black.200'}>End</Typography>  
                            </Box>
                            <Box display={'flex'} flexDirection={'row'} flex={1} gap={1} justifyContent={'flex-end'}>
                                <Typography variant='body-smaller' color={'black.200'}>Present</Typography> 
                                <Controller
                                    name="present"
                                    control={control}
                                    rules={{required: false}}
                                    render={({ field }) =>( 
                                        <KaziCheckbox
                                            {...field} 
                                            size='small' 
                                            sx={{ 
                                                '& .MuiSvgIcon-root': { fontSize: 14 }, 
                                                padding: 0, 
                                                height: '15px' 
                                            }}
                                        />
                                    )}
                                /> 
                            </Box>
                        </Box>
                        <Controller
                            name="end_date"
                            control={control}
                            rules={{required: false}}
                            render={({ field }) =>( 
                                    <DatePicker
                                        {...field}
                                        disableFuture
                                        slotProps={{
                                            textField: {
                                                placeholder: 'End month and year'
                                            },
                                            field: {
                                                clearable: true
                                            }
                                        }}
                                        value={field?.value ? moment(field.value).local() : undefined} 
                                        format='MM YYYY'
                                        views={['month', 'year']}    
                                        disabled={presentChecked}
                                    />
                            )}
                        /> 
                    </Grid>
                </Grid>
                <Grid item display={"flex"} flexDirection={"row"} gap={"12px"}>
                    <Grid item display={"flex"} flexDirection={"column"}>
                        <Typography variant='body-small' color={'black.200'} marginBottom={1}>Company</Typography>  
                        <Controller
                            name="company"
                            control={control}
                            rules={{required: true}}
                            render={({ field }) =>( 
                                <FormControl>   
                                    <InputLabel sx={{opacity: 1}}>{field.value ?"":"Company name"}</InputLabel>                   
                                    <TextField
                                        {...field}
                                        // error={hasErrors(field.name, errors)}
                                        sx={{
                                            width: "270px"
                                        }}
                                    />
                                </FormControl>
                            )}
                        />   
                    </Grid><Grid item display={"flex"} flexDirection={"column"}>
                        <Typography variant='body-small' color={'black.200'} marginBottom={1}>Title</Typography>  
                        <Controller
                            name="title"
                            control={control}
                            rules={{required: true}}
                            render={({ field }) =>( 
                                <FormControl>   
                                    <InputLabel sx={{opacity: 1}}>{field.value ?"":"Title"}</InputLabel>                   
                                    <TextField
                                        {...field}
                                        // error={hasErrors(field.name, errors)}
                                        sx={{
                                            width: "270px"
                                        }}
                                    />
                                </FormControl>
                            )}
                        />   
                    </Grid>
                </Grid>
                <Grid item xs display={"flex"} flexDirection={"column"}>
                        <Typography variant='body-small' color={'black.200'} marginBottom={1}>Job description</Typography>
                        <Controller
                            name="description"
                            control={control}
                            rules={{required: true}}
                            render={({ field }) =>(            
                                <TextField
                                    {...field}
                                    placeholder='Add a short job description describing your responsibilities'
                                    fullWidth
                                    multiline
                                    maxRows={5}
                                    // error={hasErrors(field.name, errors)}
                                    sx={{
                                        width: "100%",
                                        '& .MuiInputBase-input': {
                                        maxHeight: '126px'
                                        }
                                    }}
                                />
                            
                            )}
                        />  
                </Grid>
            </Grid>
        </>
    )
}